const popup = document.getElementById("discount-popup");
const copyBtn = document.getElementById("copy-code");
const copyStatus = document.getElementById("copy-status");
const discountCodeElement = document.getElementById("discount-code");
const discountCode = document.getElementById("discount-code").textContent;
const currentDate = new Date();

// Only show popup once per visitor 
if (!localStorage.getItem("xmasPopupShown") && currentDate.getMonth() + 1 === 12) {
    setTimeout(() => {
        popup.style.display = "flex";
    }, 3000); // 3 seconds delay
}

function closePopup() {
    popup.style.display = "none";
    localStorage.setItem("xmasPopupShown", "true");
    popup.setAttribute("aria-hidden", "true");

    // Optional: track dismissals
    document.dispatchEvent(
        new CustomEvent("popup:dismissed", {
        detail: { page: window.location.pathname, ts: Date.now(), reason: "manual_close" },
        })
    );
}

function copyToClipboard() {
    navigator.clipboard
        .writeText(discountCode)
        .then(() => {
            copyStatus.style.display = "inline";
            
            // Fire a DOM event that Shopify's pixel can listen for
            document.dispatchEvent(
                new CustomEvent("popup:copy_discount_code", {
                    detail: {
                        code: discountCode,
                        page: window.location.pathname,
                        method: "popup_click",
                        ts: Date.now(),
                    },
                })
            );

            setTimeout(closePopup, 1500);
        })
        .catch((err) => {
            console.error("Failed to copy code: ", err);
        });
}

discountCodeElement.addEventListener("click", copyToClipboard);
copyBtn.addEventListener("click", copyToClipboard);
popup.addEventListener("click", function (event) {
    if (event.target === popup) {
        closePopup()
    }
});

// Runs on every page where the pixel is loaded
document.addEventListener("popup:copy_discount_code", (e) => {
  const detail = e.detail || {};
  analytics.publish("custom_copy_discount_code", {
    code: detail.code,
    page: detail.page,
    method: detail.method,
    ts: detail.ts,
  });
});

// Optional: track dismissals
document.addEventListener("popup:dismissed", (e) => {
  const detail = e.detail || {};
  analytics.publish("custom_popup_dismissed", {
    page: detail.page,
    reason: detail.reason || "unknown",
    ts: detail.ts || Date.now(),
  });
});